module.exports = __webpack_public_path__ + "2330c497f684a5a03c1adc3109c4b22b.png";